import React, { useEffect, useRef } from 'react'
import './styles/App.css'
import './styles/Responsive.css' // Import responsive styles
import { Helmet } from 'react-helmet-async'
import { useLanguage } from './context/LanguageContext'

// Import your components
import Header from './components/Header'
import HeroSection from './components/HeroSection'
import Services from './components/Services'
import Testimonials from './components/Testimonials'
import PricingPlans from './components/PricingPlans'
import JoinSection from './components/JoinSection'
import FAQ from './components/FAQ'
import Contact from './components/Contact'
import Footer from './components/Footer'
import StructuredData from './components/StructuredData'


function ScrollSection({ children }) {
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('visible')
          observer.unobserve(el)
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={ref} className="scroll-section">
      {children}
    </div>
  )
}

function App() {
  const { language } = useLanguage()

  return (
      <div className="app-container">
        <Helmet>
          <html lang={language} />
          <title>{language === 'he' ? 'Invitly | ניהול אישורי הגעה לחתונה' : 'Invitly | Wedding RSVP Management'}</title>
          <meta name="description" content={language === 'he' ? 'נהלו את רשימת האורחים ואישורי ההגעה לחתונה שלכם בקלות. פלטפורמה חכמה לניהול האירוע המושלם.' : 'Manage your wedding guest list and RSVPs with ease. The smart platform for organizing your perfect event.'} />
          <link rel="canonical" href="https://invitly.org" />
          <link rel="alternate" hreflang="en" href="https://invitly.org" />
          <link rel="alternate" hreflang="he" href="https://invitly.org" />
          <link rel="alternate" hreflang="x-default" href="https://invitly.org" />
        </Helmet>
        <StructuredData />
        <Header />
        <HeroSection />
        <ScrollSection><Services /></ScrollSection>
        <ScrollSection><Testimonials /></ScrollSection>
        <ScrollSection><PricingPlans /></ScrollSection>
        {/* <ScrollSection><JoinSection /></ScrollSection> */}
        <ScrollSection><FAQ /></ScrollSection>
        <ScrollSection><Contact /></ScrollSection>
        <ScrollSection><Footer /></ScrollSection>
      </div>
  )
}

export default App
